type ColorsInterface = Record<string, Record<string | number, string>>

export const Colors: ColorsInterface = {
  Primary: {
    c1: "#861F41",
    accent: "#AB8476",
    900: "#861F4190",
    800: "#861F4980",
    700: "#861F4170",
    600: "#861F4160",
    500: "#861F4150",
    white: "white",
    black: "black"
  },
  Secondary: {
    c2: "#231F20",
    c2_500: "#93959880",
    c2_300: "#9395984D",
    c2_100: "#F4F4F5",
    c2_800: "#F4F4F5",
    banner: "#EEEAE7"
  },
  Alternative: {
    accent: "#AB8476",
    900: "#AB847690",
    800: "#AB847680",
    700: "#AB847670",
    600: "#AB847660",
    500: "#AB847650"
  },
  SecondaryPrimary: {
    c2: "#939598",
    900: "#93959890",
    800: "#93959880",
    700: "#93959870",
    600: "#93959860",
    500: "#93959850",
    400: "#93959840",
    300: "#93959830"
  },
  TertiaryPrimary: {
    c3: "#231F20"
  },
  TertiarySecondary: {
    "c3-1": "#097AC1"
  },
  Errors: {
    error: "#9E231C",
    700: "#9E231C70",
    300: "#9E231C30",
    100: "#9E231C10"
  },
  Background: {
    b1: "white"
  },
  Surface: {
    s1: "#93959810"
  }
}
